import React from "react";
import "babel-polyfill";
import Router from "./Router";
import { DefaultRouter } from "@tenderd/track-web-utils";
import "./style.css";
var App = function (_a) {
    return (React.createElement(DefaultRouter, { rootPath: "groups" },
        React.createElement(Router, null)));
};
export default App;
